import { createSlice } from "@reduxjs/toolkit";

const initialBformterminateState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  entities: null,
  lastError: null,
  bformterminateForEdit: undefined,
};

export const callTypes = {
  list: "list",
  action: "action",
};

export const bformterminateSlice = createSlice({
  name: "bformterminate",
  initialState: initialBformterminateState,
  reducers: {
		catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
		bformterminateFetched: (state, action) => {
      const { totalCount, entities } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.entities = entities;
      state.totalCount = totalCount;
    },
    bformterminateCreated: (state, action) => {
      state.actionsLoading = false;
      state.error = null;
      state.entities.bformterminate.push(action.payload.bformterminate);
    },
    bformterminateDeleted: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities = state.entities.bformterminate.filter(el => el.bformterminate_id !== action.payload.id);
    },
    getBformterminate: (state, action) => {
      state.actionsLoading = false;
      state.bformterminateForEdit = action.payload.bformterminateForEdit;
      state.error = null;
    },
    // updateProduct
    bformterminateUpdated: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities.bformterminate = state.entities.bformterminate.map(entity => {
        if (entity.bformterminate_id === action.payload.bformterminate.bformterminate_id) {
          return action.payload.bformterminate;
        }
        return entity;
      });
    },
  },
});
